module.exports = __webpack_public_path__ + "img/dd0bea1.svg";